import base from './base';
import palette from './palette';

const picker = {
  MuiPickersTextField: {
    defaultProps: {
      variant: 'standard',
      size: 'small',
      margin: 'normal',
    },
  },
  MuiPickersInput: {
    styleOverrides: {
      root: {
        backgroundColor: palette.common.white,
        border: `1px solid ${palette.grey[600]}`,
        borderRadius: base.shape.borderRadius,
        'label + &': {
          marginTop: '18px',
        },
        '&:before, &:after': {
          display: 'none',
        },
        '&.Mui-focused': {
          borderColor: palette.common.black,
        },
        '.Mui-required:not(.MuiFormLabel-filled) + &:not(.Mui-focused, .Mui-disabled)': {
          borderColor: palette.red[600],
        },
        '&.Mui-error:not(.Mui-focused)': {
          background: palette.red[100],
          borderColor: palette.red[600],
        },
        '.MuiFormLabel-filled + &:not(.Mui-focused, .Mui-error, .Mui-disabled)': {
          background: palette.grey[100],
          borderColor: palette.grey[600],
        },
        '&.Mui-disabled': {
          backgroundColor: palette.grey[100],
          borderColor: palette.grey[150],
        },
        '& .MuiPickersInputBase-sectionsContainer': {
          fontSize: '0.875rem',
          padding: '6px 10px 4px',
        },
        '&.MuiPickersInputBase-adornedStart': {
          paddingLeft: '10px',
        },
      },
    },
  },
};
export default picker;
